export const PARTNER_CATEGORIES = ["hebergement", "restauration", "location_vehicule", "divers"] as const;

export type PartnerCategory = (typeof PARTNER_CATEGORIES)[number];

export const PARTNER_CATEGORY_LABELS: Record<PartnerCategory, string> = {
	hebergement: "Hébergement",
	restauration: "Restauration",
	location_vehicule: "Location de véhicule",
	divers: "Divers",
};

export function isPartnerCategory(value: string): value is PartnerCategory {
	return PARTNER_CATEGORIES.includes(value as PartnerCategory);
}
